import axios from 'axios';
import MainURL from '../../Admin/MainURL';

export type ContractTypeId = 'web' | 'app' | 'maintenance' | 'consulting';

export type PaymentTerm = {
  category: string;
  amount: string;
  condition: string;
};

export type PublicContract = {
  id: number;
  customer_name: string;
  phone: string;
  contract_type: ContractTypeId | string;
  contract_name: string | null;
  product_name: string | null;
  company_name: string | null;
  representative: string | null;
  business_number: string | null;
  email: string | null;
  address: string | null;
  build_cost: string | null;
  build_period: string | null;
  maintenance_fee: string | null;
  maintenance_period: string | null;
  payment_terms: PaymentTerm[];
  special_notes: string | null;
  provider_company_name: string | null;
  provider_representative: string | null;
  provider_business_number: string | null;
  provider_contact: string | null;
  provider_address: string | null;
  provider_account_number: string | null;
  terms_text: string;
  status: string;
  signed_at?: string | null;
  terms_agreed?: boolean;
  privacy_agreed?: boolean;
  signature_name?: string | null;
  signature_image?: string | null;
};

type ApiErrorBody = {
  ok?: boolean;
  error?: { code?: string; message?: string };
  message?: string;
};

const API_BASE = `${MainURL}/api/contracts`;

function getErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as ApiErrorBody | undefined;
    if (body?.error?.message) return body.error.message;
    if (typeof body?.message === 'string') return body.message;
  }
  return fallback;
}

export async function lookupContract(customerName: string, phone: string) {
  try {
    const res = await axios.post<{ ok: boolean; data?: PublicContract }>(`${API_BASE}/lookup`, {
      customer_name: customerName,
      phone,
    });
    if (!res.data?.ok || !res.data.data) {
      throw new Error('계약 조회 응답 형식이 올바르지 않습니다.');
    }
    return res.data.data;
  } catch (err) {
    throw new Error(getErrorMessage(err, '계약 조회에 실패했습니다.'));
  }
}

export async function signContract(
  id: number,
  payload: {
    customer_name: string;
    phone: string;
    terms_agreed: boolean;
    privacy_agreed: boolean;
    signature_name: string;
    signature_image: string;
  },
) {
  try {
    const res = await axios.post<{ ok: boolean; data?: PublicContract }>(
      `${API_BASE}/${id}/sign`,
      payload,
    );
    if (!res.data?.ok || !res.data.data) {
      throw new Error('계약 서명 응답 형식이 올바르지 않습니다.');
    }
    return res.data.data;
  } catch (err) {
    throw new Error(getErrorMessage(err, '계약 서명에 실패했습니다.'));
  }
}
